import { useTranslation } from 'react-i18next';
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Row, Typography } from "antd";
import { viLocale as locale } from "../../../../../utils/pickerType";
import { get } from "lodash";
import { FC, useEffect } from "react";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";
import { useLearningRepositoryStore } from "../../../../../stores/stores";
import dayjs from "dayjs";

interface FormFilterProps {
  form: any;
  showFilter?: boolean;
  handleCloseFilter: () => void;
  clearFilter: () => void;
  dataOptions: {
    ownerList: { value: number; label: string }[];
    schoolOwnsList: { value: string; label: string }[];
    lastEditedBy: { value: number; label: string }[];
  };
}

const FormFilter: FC<FormFilterProps> = ({
  form,
  showFilter,
  handleCloseFilter,
  clearFilter,
  dataOptions,
}) => {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;
  const { tab, set } = useLearningRepositoryStore((s) => ({ tab: s.tab, set: s.set }));

  const handleFinish = (values: any) => {
    set("ownerId", values.ownerId ?? undefined);
    set("enterpriseUuid", values.enterpriseUuid ?? undefined);
    set("updaterId", values.updaterId ?? undefined);

    if (values.updatedDate?.[0] && values.updatedDate?.[1]) {
      const start = dayjs(values.updatedDate[0]).endOf("day").toISOString();
      const end = dayjs(values.updatedDate[1]).endOf("day").toISOString();
      set("updatedDate", [start, end]);
    } else {
      set("updatedDate", ["", ""]);
    }
    set("page", 1);
  };

  const handleFilterClick = () => {
    form.validateFields()
      .then((values: any) => {
        handleFinish(values);
      })
      .catch((errorInfo: any) => {
        console.log('Validation failed:', errorInfo);
      });
  };
  return (
    <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
      <Form form={form} name="filterForm" onFinish={handleFinish}>
        <Row
          gutter={[{ xs: 8, xl: 16, md: 8 }, 12]}
          className="pt-2 learning-material-filter"
        >
          {tab !== "1" &&
            <> <Col style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
              <Typography.Title level={5}>{t("Chủ sở hữu", "Chủ sở hữu")}</Typography.Title>
              <Form.Item name="ownerId">
                <FormItemDropdown
                  placeholder={t("Chọn người sở hữu", "Chọn người sở hữu")}
                  options={get(dataOptions, "ownerList", [])}
                  allowClear
                />
              </Form.Item>
            </Col>

              <Col style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                <Typography.Title level={5}>{t("Trường sở hữu", "Trường sở hữu")}</Typography.Title>
                <Form.Item name="enterpriseUuid">
                  <FormItemDropdown
                    placeholder={t("Chọn trường sở hữu", "Chọn trường sở hữu")}
                    options={get(dataOptions, "schoolOwnsList", [])}
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                <Typography.Title level={5}>{t("Người sửa đổi lần cuối", "Người sửa đổi lần cuối")}</Typography.Title>
                <Form.Item name="updaterId">
                  <FormItemDropdown
                    placeholder={t("Chọn người sửa cuối", "Chọn người sửa cuối")}
                    options={get(dataOptions, "lastEditedBy", [])}
                    allowClear
                  />
                </Form.Item>
              </Col></>}


          <Col style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <Typography.Title level={5}>{t("Thời gian sửa đổi (theo ngày)", "Thời gian sửa đổi (theo ngày)")}</Typography.Title>
            <Form.Item name="updatedDate">
              <RangePicker
                placeholder={[t("Từ ngày", "Từ ngày"), t("Đến ngày", "Đến ngày")]}
                format="DD-MM-YYYY"
                style={{ width: "100%" }}
                locale={locale}
              />
            </Form.Item>
          </Col>

          <Col style={{ display: "flex", alignItems: "flex-end" }}>
            <div style={{ display: "flex", gap: "12px" }}>
              <Button
                className="btn btn-primary search-btn"
                onClick={handleFilterClick}
              >
                <FilterOutlined />
                <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
              </Button>
              <Button
                className="btn btn-outlined clear-filter-btn"
                onClick={clearFilter}
              >
                <DeleteOutlined />
                <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default FormFilter;